import { Button, Clickable, Col, Icon, Row, Spinner, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const ConnectInFive = ({ data }) => {
  const [loading, setLoading] = useState(false),
    connect = useSelector((state) => state.connects.find((x) => x._id === data.entityId)),
    { t } = useTranslation(),
    { sender, timestamp } = data;

  function cancel() {
    if (!connect) return;
  }

  return (
    <Clickable onClick={() => null}>
      <Col noFlex pad="16px 16px 16px 19px" marg="0 0 12px" bg={theme.GREY_10}>
        <Row noFlex marg="0 0 12px" wid="100%" start>
          <Icon marg="3px 0 0" type="scheduleAvailable" dimensions={25} col={theme.GREY_50} />

          <Row between marg="0 0 0 12px" wid="100%" between>
            <Col noFlex>
              <Text>
                <Trans>
                  {t('notifications.comingUpConnect', { sender: sender.name || sender.username })}
                </Trans>
              </Text>
            </Col>

            <Text b2 med col={theme.GREY_60} marg="3px 0 0" style={{ flexShrink: 0 }}>
              {timestamp}
            </Text>
          </Row>
        </Row>

        {loading ? (
          <Row centerAll marg="12px 0 0" ht="30px">
            <Spinner />
          </Row>
        ) : (
          new Date(connect.date) > new Date() && (
            <Button
              app
              wid="fit-content"
              pad="0 20px"
              text={t('common.cancel')}
              small
              bordered
              onClick={cancel}
            />
          )
        )}
      </Col>
    </Clickable>
  );
};

export default ConnectInFive;
